import Vue from './app.js';
import {router} from './app.js';

export default {
	createActionType(context, name, idactioncategorie) {
	    Vue.http.post(
	    	'api/actiontype/new',
	      	{
		        name: name,
		        idactioncategorie: idactioncategorie
	      	}
	    ).then(response => {
	    	console.log(response.data)
	    	context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.actiontype();
				context.name = null;
				context.showSuccessCreate();
			}
		})
	},
	deleteActionType(context, id) {
		Vue.http.post(
			'api/actiontype/delete',
			{
				id: id,
			}
		).then(response => {
	    	console.log(response.data)
	    	context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.actiontype();
				context.id = null;
				context.idactioncategorie = null;
				context.showSuccessDelete();
			}
		})
	},
	createActionCategorie(context, name) {
		Vue.http.post(
			'api/actioncategorie/new',
			{
				name: name,
			}
		).then(response => {
			context.response = response.data;
			console.log(response.data)
			if (context.response.error) {
				context.showError();
			}
			else {
				context.actioncategorie();
				context.name = null;
				context.showSuccessCreate();
			}
		})
	},
	deleteActionCategorie(context, id) {
		Vue.http.post(
			'api/actioncategorie/delete',
			{
				id: id
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.actioncategorie();
				context.id = null;
				context.showSuccessDelete();
			}
		})
	},
	createDecideurFonction(context, name, iddecideurcategorie) {
		Vue.http.post(
			'api/decideurfonction/new',
			{
				name: name,
				iddecideurcategorie: iddecideurcategorie
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.decideurfonction();
				context.name = null;
				context.showSuccessCreate();
			}
		})
	},
	deleteDecideurFonction(context, id) {
		Vue.http.post(
			'api/decideurfonction/delete',
			{
				id: id
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.decideurfonction();
				context.id = null;
				context.iddecideurcategorie = null;
				context.showSuccessDelete();
			}
		})
	},
	createDecideurCategorie(context, name) {
		Vue.http.post(
			'/api/decideurcategorie/new',
			{
				name: name
			}
		).then(response => {
			console.log(response)
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.decideurcategorie();
				context.name = null;
				context.showSuccessCreate();
			}
		})
	},
	deleteDecideurCategorie(context, id) {
		Vue.http.post(
			'/api/decideurcategorie/delete',
			{
				id: id
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.decideurcategorie();
				context.name = null;
				context.showSuccessDelete();
			}
		})
	},

	create_domaine(context, name) {
		Vue.http.post(
			'/api/domaine/new',
			{
				name: name
			}
		).then(response => {
			console.log(response)
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.domaine();
				context.name = null;
				context.showSuccessCreate();
			}
		})
	},
	delete_domaine(context, id) {
		Vue.http.post(
			'/api/domaine/delete',
			{
				id: id
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.domaine();
				context.name = null;
				context.showSuccessDelete();
			}
		})
	},

	create_type_action_hatvp(context, name) {
		Vue.http.post(
			'/api/typeActionHatvp/new',
			{
				name: name
			}
		).then(response => {
			console.log(response)
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.type_action_hatvp();
				context.name = null;
				context.showSuccessCreate();
			}
		})
	},
	delete_type_action_hatvp(context, id) {
		Vue.http.post(
			'/api/typeActionHatvp/delete',
			{
				id: id
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.type_action_hatvp();
				context.name = null;
				context.showSuccessDelete();
			}
		})
	},

	create_decision(context, name) {
		Vue.http.post(
			'/api/decision/new',
			{
				name: name
			}
		).then(response => {
			console.log(response)
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.decision();
				context.name = null;
				context.showSuccessCreate();
			}
		})
	},
	delete_decision(context, id) {
		Vue.http.post(
			'/api/decision/delete',
			{
				id: id
			}
		).then(response => {
			context.response = response.data;
			if (context.response.error) {
				context.showError();
			}
			else {
				context.decision();
				context.name = null;
				context.showSuccessDelete();
			}
		})
	},
}



// WEBPACK FOOTER //
// ./assets/js/params.js